import { cn } from '@/lib/utils';

export function EmptyState({ icon, title, description, action }: {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      {icon && <div className="text-text-disabled mb-3">{icon}</div>}
      <h3 className="text-sm font-medium text-text-secondary">{title}</h3>
      {description && <p className="text-xs text-text-muted mt-1 max-w-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function LoadingState({ rows = 5, className }: { rows?: number; className?: string }) {
  return (
    <div className={cn('space-y-2', className)}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 px-4 py-3">
          <div className="h-4 w-4 rounded bg-base-hover animate-pulse" />
          <div className="h-3 w-32 rounded bg-base-hover animate-pulse" />
          <div className="h-3 w-24 rounded bg-base-hover animate-pulse" />
          <div className="h-3 w-20 rounded bg-base-hover animate-pulse" />
          <div className="h-3 w-16 rounded bg-base-hover animate-pulse" />
          <div className="h-3 w-12 rounded bg-base-hover animate-pulse ml-auto" />
        </div>
      ))}
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="h-8 w-8 rounded-full bg-status-critical/15 flex items-center justify-center mb-3">
        <span className="text-status-critical text-sm">!</span>
      </div>
      <h3 className="text-sm font-medium text-text-secondary">Something went wrong</h3>
      <p className="text-xs text-text-muted mt-1 max-w-sm">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="mt-4 px-3 py-1.5 text-xs rounded-md border border-border hover:bg-base-hover transition-colors">
          Try again
        </button>
      )}
    </div>
  );
}
